import { ItemLocationOrUrl } from 'globalTypes'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faGlobe, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import styles from './index.module.css'

export interface Props {
  content: ItemLocationOrUrl
}

library.add(faLocationDot, faGlobe)

const LocationOrUrl = ({ content }: Props) => (
  <div className={styles.wrapper}>
    <div>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon
          className={styles.icon}
          icon={['fas', Boolean(content.location) ? 'location-dot' : 'globe']}
        />
      </div>
    </div>
    <div className="text-sm">
      {Boolean(content.location) ? (
        <a
          href={`https://maps.google.com/maps?q=${encodeURIComponent(
            content.location
          )}`}
          rel="noreferrer"
          target="_blank"
        >
          {content.location}
        </a>
      ) : Boolean(content.url) ? (
        'Aula virtuale'
      ) : null}
    </div>
  </div>
)

export default LocationOrUrl
